import *as _ from 'lodash'
import {UOMBO} from "./UOMBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";

export class UOMBOValidations {

    static ValidateEmptyFields(aBO: UOMBO): Promise<void>{

        return new Promise<void>((resolve, error ) =>{
            // Validate UOM
            if (_.isEmpty(aBO.WB_UOM.cif.UOM_ID) || _.isNull(aBO.WB_UOM.cif.UOM_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'uomid',
                        title: "UOM ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('uomid')
            }

            if (_.isEmpty(aBO.WB_UOM.cif.UOM_NAME) || _.isNull(aBO.WB_UOM.cif.UOM_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'uomname',
                        title: "UOM Name cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('uomname')
            }

            if (_.isEmpty(aBO.WB_UOM.cif.SORT_ORDER?.toString()) || _.isNull(aBO.WB_UOM.cif.SORT_ORDER?.toString())) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'sortorder',
                        title: "Order cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('sortorder')
            }

            resolve()

        })

    }
}